import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useWishlist } from "../context/WishlistContext";
import ProductCard from "../components/ProductCard";
import { Heart } from "lucide-react";

export default function WishlistPage() {
  const { ids } = useWishlist();
  const [products, setProducts] = useState([]);
  useEffect(() => {
    document.title = "Favoritos · Mimes Gourmet";
    api.get("/products").then((r) => setProducts(r.data.filter((p) => ids.includes(p.id))));
  }, [ids]);
  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
      <p className="eyebrow mb-3">Tu selección</p>
      <h1 className="font-serif text-4xl sm:text-5xl text-[color:var(--brand-primary)] font-light">Tus <span className="italic text-[color:var(--brand-terracotta)]">favoritos</span></h1>
      {products.length === 0 ? (
        <div data-testid="wishlist-empty" className="mt-16 text-center">
          <Heart className="w-12 h-12 mx-auto text-[color:var(--brand-sage)]" strokeWidth={1} />
          <p className="mt-4 text-sm text-[color:var(--brand-neutral)]">Aún no has guardado ningún favorito.</p>
          <Link to="/tienda" className="inline-block mt-4 text-sm underline text-[color:var(--brand-primary)]">Explorar la tienda</Link>
        </div>
      ) : (
        <div data-testid="wishlist-grid" className="grid grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
